import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAUmnEzOOqzW83cH3IjukObGTvM9m_jN0A",
  authDomain: "ai-manifest.firebaseapp.com",
  projectId: "ai-manifest",
  storageBucket: "ai-manifest.firebasestorage.app",
  messagingSenderId: "77207750499",
  appId: "1:77207750499:web:3f2f6744163eae912df556",
  measurementId: "G-M2EH2693J9"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
